import { alpha, Typography, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const CardHeader = ({ faIcon, color, title }) => {
  const theme = useTheme();
  return (
    <Typography
      variant="h2"
      sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}
    >
      {faIcon != null && (
        <FontAwesomeIcon
          icon={faIcon}
          color={color}
          style={{
            backgroundColor: alpha(color, 0.2),
            padding: theme.spacing(1.5),
            borderRadius: theme.shape.borderRadius * 2,
          }}
        />
      )}
      {title}
    </Typography>
  );
};

export default CardHeader;
